:host {
  display: none; // initially closed
  overflow: hidden;
}

.component {
  margin: 0 $baseline-2 $baseline-2 $baseline-2;

  @include bp-sm {
    margin-bottom: $baseline-3;
  }

  &.borderless {
    margin: 0 $baseline-2 $baseline-3 0;

    &.is-last-item {
      margin-top: $baseline-3;
      margin-bottom: 0;
    }
  }
}
